'use client';

import Image from 'next/image';
import Link from 'next/link';
import classes from './Footer.module.scss';
import { IconBrandFacebook, IconBrandInstagram } from '@tabler/icons-react';
import { ActionIcon, Container, Group, Space, Text, Title } from '@mantine/core';
import { useDictionary } from '@/src/dictionaries/dictionary-provider';
import { useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import { parseJwt } from '@/src/helpers/decode-jwt';
import { FooterEditorModal } from './FooterEditorModale';

export function Footer() {
  const dictionary: any = useDictionary();
  const [isSuperAdmin, setIsSuperAdmin] = useState(false);

  useEffect(() => {
    const token = Cookies.get('authToken');
    if (token) {
      try {
        const decoded = token ? parseJwt(token) : null;
        if (decoded.role === 'superAdmin' || decoded.role === 'admin') {
          setIsSuperAdmin(true);
        }
      } catch (err) {
        console.error('Invalid token', err);
      }
    }
  }, []);

  // @ts-ignore
  const groups = dictionary.footer.links.map((group, index) => {
    // @ts-ignore
    const links = group.links.map((link, index) => (
      <Link key={index} className={classes.link} href={link.link}>
        {link.label}
      </Link>
    ));

    return (
      <div className={classes.wrapper} key={group.title + index}>
        <Text className={classes.title}>{group.title}</Text>
        {links}
      </div>
    );
  });

  return (
    <footer className={classes.footer}>
      {isSuperAdmin && <FooterEditorModal />}
      <Container className={classes.inner}>
        <div className={classes.logo}>
          <Group>
            <Image alt="logo" src="https://ik.imagekit.io/hg5cblo5w/articles/hestia-logo-150%20(1)%20copy.jpg" width={75} height={75} unoptimized />
            <h2>{dictionary.compagnyName}</h2>
          </Group>
          <Space h='lg' />
          <Text size="sm" className={classes.description}>
            {dictionary.footer.description}
          </Text>
        </div>
        <div className={classes.groups}>{groups}</div>
      </Container>
      <Container className={classes.afterFooter}>
        <Text size="sm">
          <Link href="https://hestia-innovation.com" className={classes.link}>
            Développement du site web par Hestia Innovation
          </Link>
          {dictionary.footer.copyright}
        </Text>

        <Group gap={0} className={classes.social} justify="flex-end" wrap="nowrap">
          <ActionIcon
            size="lg"
            color="gray"
            variant="subtle"
            component={Link}
            href={dictionary.footer.facebook}
            aria-label="Facebook"
            title="Facebook"
          >
            <IconBrandFacebook size={18} stroke={1.5} />
          </ActionIcon>
          <ActionIcon
            size="lg"
            color="gray"
            variant="subtle"
            component={Link}
            href={dictionary.footer.instagram}
            aria-label="Instagram"
            title="Instagram"
          >
            <IconBrandInstagram size={18} stroke={1.5} />
          </ActionIcon>
        </Group>
      </Container>
    </footer>
  );
}
